<template>
  <div v-if="subcategories.length" class="store-subcategories">
    <div v-for="subcategory in subcategories" :key="subcategory.term_id" class="store-subcategory">
      <button @click="setCategory(subcategory)">
        <div class="store-subcategory__image">
          <img :src="subcategory.thumbnail_url ? subcategory.thumbnail_url : default_url" alt="">
        </div>

        <div class="store-subcategory__content">
          <h3>{{ subcategory.name }}</h3>
        </div>
      </button>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    subcategories: Array,
  },
  data() {
    return {
      default_url: ws_vue_store.default_category_image,
    };
  },
  methods: {
    setCategory(category) {
      if(ws_vue_store.remove_search_mode_after_click == '1'){
        this.$store.commit('changeSearchMode', false);
        this.$store.state.filters.keyword = '';
        // Event to clear other search bars on site
        document.dispatchEvent(new Event('ws-clearSearch'));
      }
      this.$store.commit("setCategoryAllowedAttributes", category.store_attributes);
      this.$store.dispatch("addFilter", {
        taxonomy: category.taxonomy,
        option: category.term_id
      });
    }
  }
};
</script>